import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../api/axios';
import { API_ENDPOINTS } from '../api/endpoints';

async function fetchSoxDefaultsMappings() {
  const response = await axiosInstance.get(API_ENDPOINTS.getSoxCycleMappingsDefaults);
  return response.data;
}

export function useSoxDefaultsMappings(enabled = true) {
  const organizationId = window.localStorage.getItem('organizationId') || '';
  return useQuery({
    queryKey: ['sox-defaults-mappings', organizationId],
    queryFn: fetchSoxDefaultsMappings,
    enabled,
    staleTime: 5 * 60 * 1000
  });
}

